/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */

export type FeeCollectionTiming = typeof FeeCollectionTiming[keyof typeof FeeCollectionTiming];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeeCollectionTiming = {
  DISBURSEMENT: 'DISBURSEMENT',
  REPAYMENT: 'REPAYMENT',
  TAKEOVER: 'TAKEOVER',
  EARLY_CLOSURE: 'EARLY_CLOSURE',
} as const;
